import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=376ddb84&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('376ddb84')) {
      api.createRecord('376ddb84', component.options)
    } else {
      api.reload('376ddb84', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=376ddb84&", function () {
      api.rerender('376ddb84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/dashboard/Dashboard.vue"
export default component.exports